import {createPreloadableLazyComponent} from '../../util/lazyImport';
import {type RouteData} from '../types';
import {CREATE_SWEEP_PATH, SWEEP_PATHS} from './sweepWorkspacePaths';

export const SWEEP_ROUTES_DATA: RouteData[] = [
  {
    additionalProps: {
      allowIframes: true,
      datadogViewName: 'CreateSweep',
    },
    exact: true,
    isPrivateRoute: true,
    path: CREATE_SWEEP_PATH,
    RouteComponent: createPreloadableLazyComponent(
      () => import('../../pages/CreateSweepPage')
    ).Component,
  },
  {
    additionalProps: {
      allowIframes: true,
      datadogViewName: 'Sweep',
    },
    exact: true,
    isPrivateRoute: false,
    path: SWEEP_PATHS,
    RouteComponent: createPreloadableLazyComponent(
      () => import('../../pages/SweepPage')
    ).Component,
  },
];
